import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { waitForResponse } from '../utils/angular-service.utils';
import { ApiBaseService } from '../utils/api-base-service';
import { RequestBuilder } from '../utils/request-builder';

import type { TvViewAuthControllerValidateEventApiResponse } from '../models/responses/api-tvview-auth-responses.model';
import type { AbortablePromise } from '../utils/angular-service.utils';

/**
 * Parameters for operation tvViewAuthControllerValidateEvent
 */
type TvViewAuthControllerValidateEventParams = {
    eventPin: number;
  };

@Injectable()
export class ApiTvviewAuthService extends ApiBaseService {
  private static readonly TV_VIEW_AUTH_CONTROLLER_VALIDATE_EVENT_PATH = '/tvview/auth/{eventPin}';

  public tvViewAuthControllerValidateEvent(params: TvViewAuthControllerValidateEventParams, context?: HttpContext): AbortablePromise<TvViewAuthControllerValidateEventApiResponse> {
    const rb = new RequestBuilder(this.rootUrl, ApiTvviewAuthService.TV_VIEW_AUTH_CONTROLLER_VALIDATE_EVENT_PATH, 'get');
    rb.path('eventPin', params.eventPin, {});

    return waitForResponse<TvViewAuthControllerValidateEventApiResponse>(
      this.http.request(rb.build({
        responseType: 'text',
        accept: '*/*',
        context,
      })),
      {
        errorResponseTypes: {
          401: 'text',
          403: 'text',
          500: 'text',
        }
      }
    )
  }
}
